import React from "react";
import View from "components/tmisc/portal/adjusting/Adjusting.view";

const PortalAdjusting = ({ buildStatus }) => {
  return <View buildStatus={buildStatus} />
};

export default PortalAdjusting;
